import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { RouteLocation } from "vue-router";
import { IExtendedWithPortalTypeFilterValue } from "./IExtendedWithPortalTypeFilterValue";


export class CampaignTypeMapper  extends FilterMapper {
	public filterType: FilterType = FilterType.CAMPAIGN_TYPE;
	public isMultiSelect = false;
	private static instance: CampaignTypeMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];

	public static getInstance(): CampaignTypeMapper {
		if (!CampaignTypeMapper.instance) {
			CampaignTypeMapper.instance = new CampaignTypeMapper();
		}
		return CampaignTypeMapper.instance;
	}

	private constructor() {
		super();
	}

	public canBeIndexed(): boolean {
		return false;
	}

	public override async getExtendedFilterValuesFromRoute(route: RouteLocation): Promise<IExtendedFilterValue[]> {
		const queryKeyword = route.query?.[this.filterType];

		if (typeof queryKeyword === 'string' && queryKeyword.length > 0) {
			const filerValue = this.createExtendedFilterValue(queryKeyword);
			return filerValue ? [filerValue] : [];
		}

		return [];
	}

	private createExtendedFilterValue(keyword: string): IExtendedFilterValue | undefined {
		const text = keyword.trim();

		if(text.length === 0) return undefined;

		return {
			id: text
		};
	}
}
